<template>
  <v-dialog v-model="dialog" max-width="520" :fullscreen="$vuetify.breakpoint.smAndDown">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="!noActivator && $vuetify.breakpoint.mdAndUp"
        color="accent"
        depressed
        class="rounded-lg"
        v-on="on"
        v-bind="attrs"
        >
        Nueva gestión
      </v-btn>
    </template>

    <v-card class="iqc rounded-lg">
      <!-- header -->
      <div class="iqc__head">
        <div class="iqc__head-text">
          <h2 class="iqc__title">Nueva consulta</h2>
          <p class="iqc__sub">Registrá un contacto y el motivo de su consulta.</p>
        </div>
        <button type="button" class="iqc__close" @click="dialog = false" aria-label="Cerrar">
          <hero-icon :icon="XMarkIcon" :size="18" />
        </button>
      </div>

      <div class="iqc__divider"></div>

      <!-- body -->
      <div class="iqc__body">
        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="createInquiry">
          <v-text-field
            label="Nombre"
            v-model="attributes.name"
            :rules="required"
            outlined
            dense
            class="iqc__field"
            >
            <template v-slot:prepend-inner>
              <hero-icon :icon="UserIcon" :size="18" class="iqc__icon" />
            </template>
          </v-text-field>

          <div class="iqc__row">
            <v-text-field
              label="E-mail"
              v-model="attributes.email"
              outlined
              dense
              class="iqc__field"
              >
              <template v-slot:prepend-inner>
                <hero-icon :icon="EnvelopeIcon" :size="18" class="iqc__icon" />
              </template>
            </v-text-field>

            <v-text-field
              label="Número de teléfono"
              v-model="attributes.phone"
              :rules="required"
              outlined
              dense
              class="iqc__field"
              >
              <template v-slot:prepend-inner>
                <hero-icon :icon="PhoneIcon" :size="18" class="iqc__icon" />
              </template>
            </v-text-field>
          </div>

          <v-text-field
            label="Motivo de consulta"
            v-model="attributes.topic"
            :rules="required"
            outlined
            dense
            class="iqc__field"
            >
            <template v-slot:prepend-inner>
              <hero-icon :icon="TagIcon" :size="18" class="iqc__icon" />
            </template>
          </v-text-field>

          <v-textarea
            label="Descripción"
            v-model="attributes.message"
            :rules="required"
            outlined
            dense
            rows="3"
            class="iqc__field"
          ></v-textarea>

          <!-- footer -->
          <div class="iqc__actions">
            <v-btn text color="primary" class="rounded-lg" @click="dialog = false">
              Cancelar
            </v-btn>
            <v-btn color="accent" depressed class="rounded-lg" @click="createInquiry">
              Crear
            </v-btn>
          </div>
        </v-form>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { CreateInquiry } from "@/graphql/mutations/inquiries";
import HeroIcon from "@/components/shared/HeroIcon";
import XMarkIcon from "heroicons/24/outline/x-mark.svg";
import UserIcon from "heroicons/24/outline/user.svg";
import EnvelopeIcon from "heroicons/24/outline/envelope.svg";
import PhoneIcon from "heroicons/24/outline/phone.svg";
import TagIcon from "heroicons/24/outline/tag.svg";

export default {
  components: { HeroIcon },

  data() {
    return {
      XMarkIcon,
      UserIcon,
      EnvelopeIcon,
      PhoneIcon,
      TagIcon,
      dialog: false,
      valid: true,
      required: [v => !!v || "Campo obligatorio"],
      attributes: {
        email: null,
        name: null,
        phone: null,
        topic: null,
        message: null,
        contactId: null
      }
    };
  },

  props: {
    owner: {
      type: Object,
      required: false
    },
    noActivator: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    owner() {
      if (this.owner) {
        this.attributes.email = this.owner.email;
        this.attributes.name = this.owner.profile.name;
        this.attributes.phone = this.owner.profile.phone;
        this.attributes.contactId = this.owner.id;
      }
    }
  },

  created() {
    if (this.owner) {
      this.attributes.email = this.owner.email;
      this.attributes.name = this.owner.profile.name;
      this.attributes.phone = this.owner.profile.phone;
      this.attributes.contactId = this.owner.id;
    }
  },

  methods: {
    open() {
      this.dialog = true;
    },

    createInquiry() {
      if (this.$refs.form.validate()) {
        this.$apollo
          .mutate({
            mutation: CreateInquiry,
            variables: {
              input: {
                attributes: this.attributes
              }
            }
          })
          .then(res => {
            this.$emit("reload");
            this.$refs.form.reset();
            this.dialog = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.iqc {
  background: #fff;
  border: 1px solid #ece7de;
}

/* header */
.iqc__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 16px;
}
.iqc__title {
  font-size: 19px;
  font-weight: 700;
  color: #1a1814;
  margin: 0;
  line-height: 1.2;
}
.iqc__sub {
  font-size: 13px;
  color: #756f64;
  margin: 5px 0 0;
}
.iqc__close {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: #a39a8c;
  transition: background 0.15s ease, color 0.15s ease;
}
.iqc__close:hover {
  background: #f1ece3;
  color: #1a1814;
}

.iqc__divider {
  height: 1px;
  background: #ece7de;
}

/* body */
.iqc__body {
  padding: 20px 24px 22px;
}

.iqc__row {
  display: flex;
  gap: 12px;
}
.iqc__row > .iqc__field {
  flex: 1;
  min-width: 0;
}
@media (max-width: 540px) {
  .iqc__row {
    flex-direction: column;
    gap: 0;
  }
}

.iqc__icon {
  color: #a39a8c;
  margin-right: 6px;
  align-self: center;
}

/* footer */
.iqc__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
}

/* rounded outlined fieldsets (Vuetify draws the border on a <fieldset>) */
.iqc__field >>> .v-text-field--outlined fieldset {
  border-radius: 10px;
}
.iqc__field >>> .v-input__slot {
  transition: border-color 0.15s ease;
}
</style>
